import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ValidationAccountService from "../../services/ValidationAccountService";
import apiClient from "../../auth/apiClient";

const useOnePass = (userID) => {
  const validationAccountService = new ValidationAccountService(apiClient);
  const [isOnePassEnabled, setIsOnePassEnabled] = useState(false);
  const currentFacility = useSelector(state => 
    state.coreEntities?.ContextID || state.entities?.ContextID
  );
  const scopeAwareFacilityID = useSelector(state =>
    state.entityScope?.facilityGroupId || currentFacility
  );

  useEffect(() => {
    const fetchOnePassStatus = async () => {
      if (!userID) return;

      try {
        const response = await validationAccountService.getValidationAccountsForUser(
          scopeAwareFacilityID,
          userID,
          true
        );
        const contractHolderIDs = response?.data.map(x => x.contractHolderID);
  
        const responses = await Promise.all(
          contractHolderIDs.map(account =>
            validationAccountService.getValidationAccountOnePassDetails(account, scopeAwareFacilityID)
          )
        );
  
        const hasActiveOnePass = responses.some(res => res.data?.active);
        setIsOnePassEnabled(hasActiveOnePass);
      } catch (err) {
        console.error("Error fetching OnePass status:", err);
      }
    };

    fetchOnePassStatus();
  }, [userID, scopeAwareFacilityID]);

  return { isOnePassEnabled };
};

export default useOnePass;
